
// src/components/Cards.jsx

import React from "react";

import { ArrowUpRight, MapPin, Wifi, ShieldCheck } from "lucide-react";

import { apartmentData } from "../utils/image-data";

import "./Cards.css";

/*
  Pulls every local apartment image from image-data.js.

  Existing pages can still use:
  import { pics } from "../components/Cards";
*/
export const pics = apartmentData.flatMap((apartment) => apartment.images);

export function RoomCard({
  i = 0,
  name = "Study Apartment",
  details = "3 Bedrooms · Smart automated living",
  price = "From ₦300,000 / night",
  rating = "4.95",
  image,
}) {
  // Randomly picks an image from index 1 to 6 of the pics array on every render.
  const randomIndex = Math.floor(Math.random() * 6) + 1;
  // const backgroundImage = pics[randomIndex];
  const backgroundImage = image || pics[randomIndex];

  return (
    <article className="room-card">
      <div
        className="room-card__image"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover'
        }}
      >
        <span>★ {rating}</span>
      </div>

      <h3>{name}</h3>

      <p>{details}</p>

      <b>{price}</b>
    </article>
  );
}

export function InfoCard({
  icon = "wifi",
  title = "Exceptional comfort",
  text = "Thoughtful details and beautiful spaces designed around your stay.",
}) {
  const Icon = icon === "map" ? MapPin : icon === "shield" ? ShieldCheck : Wifi;

  return (
    <article className="info-card">
      <Icon size={18} />

      <h3>{title}</h3>

      <p>{text}</p>

      <ArrowUpRight size={15} />
    </article>
  );
}

export function Logos() {
  return (
    <div className="logos container">
      <span>The Bryan Residence</span>
      <span>Luxury Living</span>
      <span>Smart Stays</span>
      <span>Lekki Phase 1</span>
      <span>Extraordinary Stays</span>
    </div>
  );
}









